import {
  IssueCode,
  WorkingStepType,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const notAllowedWorkingStepsSelector =
  (bomItemId: string) =>
  (state: RootAppState): WorkingStepType[] => {
    if (!state.project.activeProject) {
      return null
    }

    const bomItem = bomItemSelector(state, bomItemId)

    if (!bomItem) {
      return null
    }

    switch (bomItem?.type) {
      case 'Row':
        const workingStepNotAvailableIssue = bomItem.issues.find(
          (x) => x.issueCode === IssueCode.WorkingStepNotAvailable
        )

        if (!workingStepNotAvailableIssue) {
          return null
        }

        return JSON.parse(workingStepNotAvailableIssue?.metadata || '{}')[
          'NotAllowedWorkingSteps'
        ]
      default:
        return null
    }
  }
